import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';

const ModuleRecordsPerPageDropdown = ({ selectedPerPageItems, perPageItemsOptions, setFilter }) => {
    const [perPageItems, setPerPageItemsOptions] = useState(selectedPerPageItems);

    useEffect(() => {
        setPerPageItemsOptions(selectedPerPageItems);
    }, [selectedPerPageItems]);

    return (
        <Form.Group className="listing-count-options m-0 p-0">
            <Form.Select
                value={perPageItems}
                onChange={(e) => {
                    setPerPageItemsOptions(e.target.value);
                    setFilter('limit', e.target.value);
                }}
                className={perPageItems!="10" ? 'has-value' : 'no-value'}
            >
                {perPageItemsOptions.map(option => (
                    <option key={option} value={option}>{option} Records</option>
                ))}
            </Form.Select>
        </Form.Group>
    );
};

export default ModuleRecordsPerPageDropdown;
